<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Actualizar contraseña</h5>
        <button type="button" class="btn-close" (click)="modalService.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-12 mb-3">
                                    <label >Nueva contraseña</label>
                                    <ng-container>
                                        <div class="input-group">
                                            <input
                                                    class="form-control"
                                                    id="pass"
                                                    [type]="showPass ? 'text' : 'password'"
                                                    placeholder="Contraseña"
                                                    required="true"
                                                    [(ngModel)]="newPass"
                                            />
                                            <button
                                                    type="button"
                                                    class="btn btn-outline-primary"
                                                    (click)="togglePasswordVisibility(showPass)"
                                            >
                                                <i class="fa" [ngClass]="showPass ? 'fa-eye-slash' : 'fa-eye'"></i>
                                            </button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary"  (click)="modalService.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="saveSelection()">Actualizar</button>
    </div>
</div>
